import {
  IS_LOADING,
  USERS_LOADING,
  USER_DATA_LOADING,
  ALL_STORES,
  STORE_ADDED,
  FETCHED_RECORD,
  UPDATE_GALLERY,
  ADMIN_ROLES,
  APPROVERS,
  OFFICES,
  USERS,
  TOGGLE_USER_STATUS,
  UPDATE_PROFILE_IMAGE,
  DEPARTMENTS
} from "./userActionsTypes";

const INITIAL_STATE = {
  isLoading: false,
  usersLoading: false,
  userDataLoading: false,
  adminRoles: [],
  offices: [],
  departments: [],
  approvers: [],
  users: [],
  usersListContext: null, // { limit, isActive, officeId, departmentId } for the current users list (skip refetch when matching)
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case USERS_LOADING:
      return {
        ...state,
        usersLoading: action.payload,
      };
    case USER_DATA_LOADING:
      return {
        ...state,
        userDataLoading: action.payload,
      };
    case ADMIN_ROLES:
      return {
        ...state,
        adminRoles: action.payload[0],
      };
    case OFFICES:
      return {
        ...state,
        offices: action.payload[0],
      };
    case DEPARTMENTS:
      return {
        ...state,
        departments: action.payload[0],
      };
    case APPROVERS:
      return {
        ...state,
        approvers: action.payload[0],
      };
    case USERS:
      return {
        ...state,
        users: action.payload,
        usersListContext: action.context !== undefined ? action.context : state.usersListContext,
        usersLoading: false,
        userDataLoading: false,
      };
    case TOGGLE_USER_STATUS:
      return {
        ...state,
        users: {
          ...state.users,
          isActive: action.payload.isActive,
        },
      };
    case UPDATE_PROFILE_IMAGE:
      return {
        ...state,
        users: {
          ...state.users,
          imageUrl: action.payload.imageUrl,
        },
      };
    default:
      return state;
  }
};
